import { render } from "./BaseInput.vue?vue&type=template&id=39908b5e&ts=true"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/ilink-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__